// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR"};